// extracted by mini-css-extract-plugin
export default {"wrap":"DeleteConfirmation_wrap__VMVUR","input":"DeleteConfirmation_input__0uBt7"};